import { ResponseService } from './response.service';
import { ApiService } from './api.service';
import { Injectable, Output } from '@angular/core';

@Injectable()
export class RodoService {
    
    constructor(
        public apiService: ApiService
    ) { }

    checkRodo() {
        //console.log('Checking rodo');
        return this.apiService.get('/rodo/client').map((response) => {
            //console.log(response.status.message);
            //console.log(response.status.message == 'rodo.client.acceptance_required');
            if (response.status.message === 'rodo.client.acceptance_required') {
                return false;
            }
            return true;
        }, (error) => {
            return false;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/services/rodo.service.ts